import apis from "../../api/yj";
import fddapis from "../../api/fdd";
import LoanDetail from "../LoanDetail/index.vue";
import YjDetail from "../YjDetail/index.vue";
import {toExcelUtils} from "../../utils/toExcelUtils";
import {dateUtils} from "../../utils/dateUtils"
import {utils} from "../../utils/utils";

export default {
    name: "MyGuarantee",
    components: {
        LoanDetail,
        YjDetail
    },
    data() {
        return {
            query: {
                keyword: "",
                type: "10",
                state: "",
                moneystate:"",
                pageIndex: 1,
                pageSize: 10,
                startTime: '',
                endTime:'',
            },
            firstType:"",
            dateRange:'',
            tableCols: [
                {
                    "prop": "UserName",
                    "label": "签约人",
                    "align": "center",
                    "width": "100",
                },
                {
                    "prop": "CompanyName",
                    "label": "签约单位",
                    "align": "center",
                    "width": "",
                },
                {
                    "prop": "BankName",
                    "label": "签约银行",
                    "align": "center",
                    "width": "",
                },
                {
                    "prop": "Money",
                    "label": "金额/万元",
                    "align": "center",
                    "width": "100",
                },
                {
                    "prop": "Type",
                    "label": "合同类型",
                    "align": "center",
                    "width": "120",
                },
                {
                    "prop": "CreateTime",
                    "label": "创建时间",
                    "align": "center",
                    "width": "160",
                },
                {
                    "prop": "State",
                    "label": "签约状态",
                    "align": "center",
                    "width": "100",
                },
                                {
                    "prop": "MoneyState",
                    "label": "还款状态",
                    "align": "center",
                    "width": "100",
                },
                {
                    "prop": "Operation",
                    "label": "操作",
                    "width": "280",
                    "align": "center"
                }
            ],
            tableData: [],
            AllTypeList:[],
            typeList:[{Id:"10",name:"应急转贷合同"},{Id:"1",name:"反担保保证合同"},{Id:"2",name:"反担保抵押合同"},{Id:"3",name:"委托担保合同"},
              {Id:"4",name:"委托担保展期合同"},{Id:"5",name:"质押反担保合同"},{Id:"6",name:"最高额保证合同"},{Id:"7",name:"最高额反担保抵押合同"},{Id:"8",name:"最高额反担保抵押合同"}],
            states:["待签约","已签约","未签约"],
            moneystates:["待划款","已划款","已还款","已逾期"],
            pageTotal: 0,
            totalMoney:0,
            scrollHeight: 400,
            statusDialogShow:false,
            changeStatusRow:{},
            changeStatus:'',
            changeEndTime: '',
            detailDialogShow:false,
            detailRow:{},
            importVisible:false,
            errorTips:null,
            fileList:[]
        };
    },
    created() {
        this.getData();
    },
    mounted() {
        let that = this;
        that.calcTableHeight();
        // 注：window.onresize只能在项目内触发1次
        window.onresize = function windowResize() {
            that.calcTableHeight();
        }
    },
    methods: {
        handleEmpty(){
             this.query= {
              keyword: "",
              type: "10",
              state: "",
              moneystate:"",
              pageIndex: 1,
              pageSize: 10,
              startTime: '',
              endTime:'',
          }
          this.dateRange='';
        },
        refreshList() {
            this.getData()
        },
        getData() {
            let param = utils.deepCopy(this.query);
            if (param && this.dateRange) {
                param.startTime = dateUtils.dateToStr("yyyy-MM-dd 00:00:00",this.dateRange[0])
                param.endTime = dateUtils.dateToStr("yyyy-MM-dd 23:59:59",this.dateRange[1])
            }
            var that=this;
            apis.getContractByCondition(param).then(res => {
                if(res){
                this.$data.tableData = res.list;
                this.$data.pageTotal = res.count;
                this.$data.totalMoney=res.totalMoney.toFixed(2)
            } else that.$message.error("查询失败")
            });
        },
        getTypeName(type){
                 var typename="";
                 var typeList=this.typeList;
                 for(var i=0;i<typeList.length;i++){
                    if(type==typeList[i].Id){
                        typename=typeList[i].name;
                        break;
                    }
                 }
                 return typename;
        },
        handleView(row) {
            let that = this
            if(!row.FlowId){
                that.$message.error("暂无信息");return;
            }
            let param={
                Id:row.FlowId
            }
            if(row.Type==10){
                param.CompanyCode=row.CompanyCode;
                param.IdCard=row.IdCard;
                that.$refs.yjDetail.onChangeOpen()
                that.$refs.yjDetail.queryData(param)
            }else{
                that.$refs.loanDetail.onChangeOpen()
                that.$refs.loanDetail.queryData(param)
            }
            

        
        },
        handlePreView(row,type){
                     let param={Id:row.FddSignId}
                     if(type==2)param.actor="down";
                     var that=this;
                    fddapis.getFddSignView(param).then(res => {
                           if(res){
                              window.open(res);
                           }else{
                                  that.$message.error("获取相关链接失败");
                                }
                    });
        },
        openDetailDialogShow(row){
          this.detailDialogShow = true
          var that =this;
          apis.getContractById({Id:row.Id}).then(res => {
            if(res!=null){
                  res.FileList=JSON.parse(res.FileListStr)
                  that.detailRow = res;
            }else{
                that.$message.error("查询失败");
            }
           });
        },
        openStatusDialog(row){
            this.changeStatusRow = row
            this.statusDialogShow = true
            this.fileList=[]
            if(row.FileListStr)this.fileList=JSON.parse(row.FileListStr)
            this.changeStatus = row.MoneyState+""
            this.changeEndTime = row.ReturnDate
        },
        // 分页导航
        handlePageChange(val) {
            this.query.pageIndex = val;
            this.getData();
        },
        handleSizeChange(val) {
            this.query.pageIndex = 1;
            this.query.pageSize = val;
            this.getData();
        },
        toExcel(flag) { //表格导出
            let that = this
            let param = utils.deepCopy(this.query);
            if (param && this.dateRange) {
                param.startTime = dateUtils.dateToStr("yyyy-MM-dd 00:00:00",this.dateRange[0])
                param.endTime = dateUtils.dateToStr("yyyy-MM-dd 23:59:59",this.dateRange[1])
            }
            param.pageIndex = 1
            param.pageSize= 100000
            param.flag=flag;
            apis.excelExportContract(param).then(res => {
                if(res){
                    window.open(res)
                }else{
                    that.$message.error("导出失败") 
                }
            });
        },
        calcTableHeight() {
            this.$nextTick(() => {
                var height1 = $(".content-box .content").height();
                var height2 = $("#yj_demo").height();
                var height = height1 - height2 - 140;
                this.scrollHeight = height;
            });
        },
        getoCreateReport(){
            var row=this.detailRow;
            var param={
                keyword:"",
                idCard:row.IdCard,
                code:row.CompanyCode,
              }
            if(row.CompanyName){
                param.keyword=row.CompanyCode;
            }else{
               param.keyword=row.UserName;
            }
            let routerJump = this.$router.resolve({ path: '/CreditReport', query: param });
            window.open(routerJump.href, '_blank');
          },
      changeStatusSubmit(){
            var that=this;
            var FileListStr=JSON.stringify(that.fileList)
            if(FileListStr==this.changeStatusRow.FileListStr &&this.changeStatus==this.changeStatusRow.MoneyState && this.changeEndTime == this.changeStatusRow.ReturnDate){
                this.statusDialogShow = false
                return
            }
            var date=this.changeEndTime;
            if(typeof(date)=='object'){
                var month = (date.getMonth() + 1).toString().length == 2 ?(date.getMonth() + 1) : ("0" + (date.getMonth() + 1));
                date = date.getFullYear() + "-" + month + "-" + date.getDate();
            }
            //发送请求，封装参数
            let obj = {
                MoneyState:this.changeStatus,
                ReturnDate:date,
                Id:this.changeStatusRow.Id,
                FileListStr:FileListStr
            }
            apis.toUpdateContract(obj).then(res=>{
                if(res){
                    this.$message.success("变更成功")
                    that.statusDialogShow = false
                    that.getData()
                }else{
                     this.$message.success("变更失败")
                }
            })
        },

        beforeAvatarFileUpload(file) {
        let that = this
        const isLt2M = file.size/1024/1024 <10
        if(!isLt2M){
            that.$message.error("上传文件大小不能超过10MB") 
            return false 
        }
        return true
      },
      uploadFileFile_FJ(item){
        let that = this
        let fileObj = item.file
        const form = new FormData()
        form.append("file",fileObj)
        apis.uploadFile(form).then(res => {
            that.fileList.push({
              name: fileObj.name,
              url:res.fullPath
            })
        });
      },
      getFileName(path){
        var pos1 = path.lastIndexOf('/');
        var pos2 = path.lastIndexOf('\\');
        var pos  = Math.max(pos1, pos2)
        if( pos<0 )
            return path;
        else
            return path.substring(pos+1);
      },
      handleFileRemove_FJ(file) {
        let that = this
        if(file){
          for(let i=0;i<that.fileList.length;i++){
            if(file.url===that.fileList[i].url){
                that.fileList.splice(i,1)
              }
            
          }
        }
      },
      handleFileView(file){
            window.open(file.url);
      },
      handleExceed(){
        this.$message.error("数量超出限制，请先移除原有文件");
      },
    },

};
